<template>
  <v-container fluid class="ma-4 mt-3 px-8">
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="form.usn_id"
            label="USN*"
            outlined
            hide-details="auto"
            dense
            :rules="[rules.required]"
            clearable
          />
        </v-col>
        <v-col cols="3">
          <v-btn
            color="primary"
            @click="getDocument"
            :disabled="!form.usn_id"
            :loading="loading"
          >
            Fetch Documents
          </v-btn>
        </v-col>
      </v-row>

    <v-card class="mt-6" outlined v-if="documents.length">
      <v-card-title class="font-weight-bold"> Student Details </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="4"><b>Name:</b> {{ student.name || "-" }}</v-col>
          <v-col cols="4"><b>Gender:</b> {{ student.gender || "-" }}</v-col>
          <v-col cols="4"><b>Date of Birth:</b> {{ student.dob || "-" }}</v-col>
          <v-col cols="4"><b>Email:</b> {{ student.email || "-" }}</v-col>
          <v-col cols="4"><b>Degree:</b> {{ student.degree || "-" }}</v-col>
          <v-col cols="4"
            ><b>Programme:</b> {{ student.programme || "-" }}</v-col
          >
          <v-col cols="4"><b>Partner:</b> {{ student.partner || "-" }}</v-col>
          <v-col cols="4"
            ><b>Employee ID:</b> {{ student.employee_id || "-" }}</v-col
          >
          <v-col cols="4"
            ><b>Application ID:</b> {{ student.application_id || "-" }}</v-col
          >
        </v-row>
      </v-card-text>
    </v-card>

    <v-card v-if="documents.length" class="mt-6" outlined>
      <v-card-title class="font-weight-bold">Student Documents</v-card-title>

      <v-list two-line>
        <v-list-item
          v-for="(doc, index) in documents"
          :key="index"
          @click="openDocument(doc)"
        >
          <v-list-item-icon>
            <v-icon>
              {{ doc.type === "pdf" ? "mdi-file-pdf-box" : "mdi-image" }}
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ getFriendlyName(doc.filename) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ doc.filename }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon>
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
    <!-- Popup -->
    <attachmentViewer
      v-if="dialog"
      @closeDialog="dialog = false"
      :value="dialogData"
    />
  </v-container>
</template>
<script>
import attachmentViewer from "@/components/attachmentViewer.vue";
import { rules } from "@/helpers/rules";

export default {
  components: { attachmentViewer },
  props: {},
  data: () => ({
    rules,
    form: {},
    folders: [
      { id: "aadhar", text: "Aadhar" },
      { id: "profile", text: "Photo" },
      { id: "pan", text: "Pan" },
    ],
    dialog: false,
    dialogData: {},
    documents: [],
    loading: false,
    student: {},
  }),
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Document Viewer" }]);
  },
  methods: {
    openDialog(data) {
      this.dialogData = data;
      this.dialog = true;
    },
    async getDocument() {
      this.loading = true;
      try {
        this.documents = [];
        this.student = {};
        const response = await this.$axios.get(`/get_student_documents`, {
          params: {
            ...this.form,
          },
        });
        this.documents = response.data.data?.documents || [];
        this.student = response.data.data?.student_data || [];
      } catch (error) {
        const errorMessage = await this.$store.dispatch(
          "throwError",
          error.response,
        );
        this.$store.commit("showSnackbar", {
          message: errorMessage,
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    openDocument(item) {
      this.dialogData = { ...item };
      this.dialog = true;
    },
    getFriendlyName(filename) {
      const parts = filename.split("_");

      const docCode = parts[1] || "";

      const docMap = {
        "10th": "10th Marksheet",
        "12th": "12th Marksheet",
        UGDEGREE: "UG Degree Certificate",
        GovernmentID: "Government ID",
      };

      if (docMap[docCode]) {
        return docMap[docCode];
      }

      if (docCode) {
        return `${docCode}`;
      }

      return filename;
    },
  },
};
</script>
